
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart",
      function () {
        return require("private-next-pages/cart/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart"])
      });
    }
  